import Vue from 'vue';
import { s_messaging } from "./schmucklicloud";
import firebase from "./firebase";

const NotificationsReceiver = Vue.observable({
  notification: ""
});

const Notifications = {
  show(notification){
    NotificationsReceiver.notification = notification;
  }
};

const PushNotification = {
  turnOn: async function () {
    if (!("Notification" in window)) {
      Notifications.show(
        "This browser does not support desktop notification"
      );
    }

    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      await PushNotification.setup();
    }

    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
      var permission = await Notification.requestPermission();

      if (permission === "granted") {
        //var notification = new Notification("Permission granted!");
        await PushNotification.setup();
      } else {
        Notifications.show("You are signed in but this device will not receive any notifications.");
      }
    } else {
      Notifications.show("You will not receive any notifications on this device.");
    }
  },

  turnOff: async function() {
    var response = await s_messaging.getAllAssignedTokens();
    if (response.status === 200) {
      const messaging_client = firebase.messaging();
      var token = await messaging_client.getToken();

      response.body.forEach(async function(item) {
        if (item.token === token) {
          var delete_response = await s_messaging.deleteAssignedToken(item.id);
          if (delete_response.status === 200) {
            window.localStorage.setItem("notification", false);
          }
        }
      }.bind(this));

      Notifications.show("Notifications has been disabled.");
    }
  },

  setup: async function() {
    const messaging_client = firebase.messaging();

      var token = await messaging_client.getToken();
      if (token) {
        var assign_response = await s_messaging.assignTokenToUser(token);
        if (assign_response.status !== 200) {
          Notifications.show(
            "It's not possible to receive notifications on this device."
          );
          window.localStorage.setItem("notification", false);
        } else {
          window.localStorage.setItem("notification", true);
        }
      } else {
        Notifications.show(
          "It's not possible to receive notifications on this device."
        );
      }

      //Add event listener after sign in
      var messaging = firebase.messaging();
      messaging.onMessage(payload => {
        if (payload.data.notification) {
          var notification = JSON.parse(payload.data.notification);
          const notificationTitle = notification.title;
          const notificationOptions = {
            body: notification.description,
            icon: "/apple-icon.png",
            badge: '/badge.png',
            vibrate: [300, 100, 400]
          };
          var o_notification = new Notification(notificationTitle, notificationOptions);
          o_notification.onclick = function() {
            notification.onclick = function() {
              window.open('https://tasks.schmuckli.dev/');
            };
          }
        }
      });
  }
}

export { NotificationsReceiver, Notifications, PushNotification};